import { render } from "./CaseStudies.vue?vue&type=template&id=176f9d5a&scoped=true"
import script from "./CaseStudies.vue?vue&type=script&lang=js"
export * from "./CaseStudies.vue?vue&type=script&lang=js"

import "./CaseStudies.vue?vue&type=style&index=0&id=176f9d5a&scoped=true&lang=scss"

import exportComponent from "/Users/leopons/Desktop/1_bm_dev/bubblemaps-showcase/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-176f9d5a"]])

export default __exports__